import { writable } from 'svelte/store';
import type { ManageAPI } from "~/manage-api/types";
import type { StoresKey } from "~/stores";

// Global store for the offer modal
export const currentOfferId = writable<number>(0); // 0 means closed, any other number is the offer ID
export const currentOfferDetails = writable<ManageAPI.Offer | null>(null); // Store the complete offer object
export const currentRequestStoreKey = writable<StoresKey | null>(null);

// Helper functions to open and close the global modal
export function openOfferModal(
  offerId: number, 
  offerDetails: ManageAPI.Offer, 
  requestStoreKey: StoresKey
): void {
  currentOfferId.set(offerId);
  currentOfferDetails.set(offerDetails);
  currentRequestStoreKey.set(requestStoreKey);
}

export function closeOfferModal(): void {
  currentOfferId.set(0);
  currentOfferDetails.set(null);
  // We don't reset requestStoreKey as it might be needed again
}